import React from 'react';
import { AffinityGraphNode, AffinityGraphLink } from './affinity.types';
import { tierColor, nodeRadius } from './affinity.constants';
import { ForceNetworkGraph } from '../../../../components/NetworkGraph/ForceNetworkGraph';

interface Props {
  nodes: AffinityGraphNode[];
  links: AffinityGraphLink[];
  onNodeClick: (node: AffinityGraphNode) => void;
  rootId?: string;
  height?: number;
}

// Thin domain wrapper over the shared ForceNetworkGraph: all layout machinery
// (position cache, forces, root pinning, drag-to-pin, pendingState styling)
// lives in the shared component; only the tier colors/radii/labels are ours.
export const AffinityGraph: React.FC<Props> = ({ nodes, links, onNodeClick, rootId, height = 520 }) => (
  <ForceNetworkGraph<AffinityGraphNode>
    nodes={nodes}
    links={links}
    nodeColor={(n) => tierColor(n.tier, n.type)}
    nodeRadius={(n) => nodeRadius(n.type, n.tier)}
    nodeLabel={(n) => ({ text: n.name || '', bold: n.type === 'sub_profession' })}
    onNodeClick={onNodeClick}
    rootId={rootId}
    height={height}
  />
);
